module.exports = __webpack_public_path__ + "img/35A.fed474c5.png";